export function lsPut(key, object) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    localStorage.setItem(key, JSON.stringify(object));
    return true;
  } catch (err) {
    console.error("Failed to save to localStorage", err);
    return false;
  }
}

export function lsGet(key, fallback = null) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return fallback;
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (err) {
    console.error("Failed to read/parse from localStorage", err);
    return fallback;
  }
}

export function lsRemove(key) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    localStorage.removeItem(key);
    return true;
  } catch (err) {
    console.error("Failed to remove from localStorage", err);
    return false;
  }
}

export function lsRemoveByPrefix(prefix) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return 0;
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) keysToRemove.push(key);
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    return keysToRemove.length;
  } catch (err) {
    console.error("Failed to remove items from localStorage by prefix", err);
    return 0;
  }
}
